import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import RingCustomizerContainer from './pages';
import URLScreening from './pages/URLScreening';

function App() {
  return (
    <div className="tw-flex tw-flex-col app-container">
      <BrowserRouter>
        <Switch>
          <Route
            exact
            path={[
              '/rings/profiles/:profile/widths/:width/ring_materials/:ring_materials',
              '/:pathPrefix/rings/profiles/:profile/widths/:width/ring_materials/:ring_materials'
            ]}
            render={(props) => <RingCustomizerContainer type={1} {...props} />}
          />
          <Route
            exact
            path={[
              '/women/rings/styles/:styles/ring_materials/:ring_materials/color_arrangements/:color_arrangements/stone_quantities/:stone_quantities/variants/:variants',
              '/:pathPrefix/women/rings/styles/:styles/ring_materials/:ring_materials/color_arrangements/:color_arrangements/stone_quantities/:stone_quantities/variants/:variants'
            ]}
            render={(props) => <RingCustomizerContainer type={2} {...props} />}
          />
          <Route
            exact
            path={[
              '/rings/:ring_type/ring_materials/:ring_materials',
              '/:pathPrefix/rings/:ring_type/ring_materials/:ring_materials'
            ]}
            render={(props) => <RingCustomizerContainer type={3} {...props} />}
          />
          <Redirect
            exact
            path="/"
            to="/helzberg/rings/profiles/D/widths/7/ring_materials/14KW?ring_finish=SATIN&finish_type=F&weight=P&size=10&feature_group=N&sleeve=NONE"
          />
          <Route exact path="*" render={(props) => <URLScreening {...props} />} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
